// Marks the fields that recorders serialising the DOM — Sentry replay, the terms-agreement
// snapshot — must block. client-v2 deep-imports this module, so it must stay import-free.

// The inputs that hold a typed bank credential (routing and account numbers).
const BANK_CREDENTIAL_ATTRIBUTE = 'data-bank-credential';

export const BANK_CREDENTIAL_PRIVACY = Object.freeze({
  selector: `[${BANK_CREDENTIAL_ATTRIBUTE}]`,
  domProps: Object.freeze({ [BANK_CREDENTIAL_ATTRIBUTE]: true }),
});

// The billing address the payer types into the Adyen card form. The SDK renders those inputs, so
// no marker can reach them; the selector is the class the SDK puts on their fieldset.
const CARD_BILLING_ADDRESS_SELECTOR = '.adyen-checkout__fieldset--billingAddress';

// Every selector a recorder blocks. client-v2 reads this list; v1 still blocks the bank
// credentials only.
export const RECORDER_BLOCK_SELECTORS = Object.freeze([BANK_CREDENTIAL_PRIVACY.selector, CARD_BILLING_ADDRESS_SELECTOR]);
